// import React, { useState, useRef } from "react";
// import { Alert, Grid, TextField, TextareaAutosize } from "@mui/material";
// import FormContainer from "../../../../../components/Forms/FormContainer";
// import { ExecuteApiToPost } from "../../../../../services/api/ExecuteApiRequests";

// const initialData = {
//   id: "",
//   name: "",
//   region: "",
//   compound_boundary: null,
//   specialization: "",
//   developed_by: "",
//   area_on_plan: "",
//   current_status: "",
//   description: "",
//   abbrevation: "",
//   zone: "",
//   city: "",
//   center_of_park: null,
//   pid: "",
//   woreda: "",
//   address: "",
//   distance_from_capital: "",
// };

// function RegisterPark() {
//   const [formData, setFormData] = useState(initialData);
//   const [responseMessage, setResponseMessage] = useState(null);
//   const compoundBoundaryRef = useRef(null);
//   const centerParkRef = useRef(null);

//   const handleValueChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleFileChange = (e, field) => {
//     const file = e.target.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (event) => {
//         const hexValue = event.target.result.trim();
//         setFormData((prev) => ({ ...prev, [field]: hexValue }));
//       };
//       reader.onerror = () => {
//         alert("Error reading file");
//       };
//       reader.readAsText(file);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     console.log("Form Data before submission:", formData);

//     if (!formData.id) {
//       setResponseMessage(<Alert severity="error">ID is required</Alert>);
//       return;
//     }

//     const formDataToSend = new FormData();
//     for (const key in formData) {
//       formDataToSend.append(key, formData[key]);
//     }

//     try {
//       const data = await ExecuteApiToPost("parks", formDataToSend);
//       if (data) {
//         setResponseMessage(<Alert severity="success">Park registered successfully</Alert>);
//         // Clear form data and file inputs
//         setFormData(initialData);
//         compoundBoundaryRef.current.value = ""; // Clear the file input
//         centerParkRef.current.value = ""; // Clear the file input
//       }
//     } catch (error) {
//       setResponseMessage(<Alert severity="error">Error registering park</Alert>);
//       console.error("Error registering park:", error);
//     }
//   };

//   return (
//     <>
//       <FormContainer title="Park Registration" onSubmit={handleSubmit}>
//         {Object.keys(initialData).map((key) => (
//           <Grid item xs={12} key={key}>
//             {key === "description" ? (
//               <TextareaAutosize
//                 aria-label={`${key.charAt(0).toUpperCase() + key.slice(1)} Description`}
//                 name={key}
//                 minRows={4}
//                 placeholder={`${key.charAt(0).toUpperCase() + key.slice(1)} Description`}
//                 style={{
//                   width: "100%",
//                   padding: 10,
//                   borderRadius: 4,
//                   borderColor: "#c4c4c4",
//                   marginBottom: "16px",
//                 }}
//                 value={formData[key]}
//                 onChange={handleValueChange}
//               />
//             ) : key === "compound_boundary" ? (
//               <input
//                 type="file"
//                 accept=".txt"
//                 onChange={(e) => handleFileChange(e, key)}
//                 ref={compoundBoundaryRef} // Assign ref
//                 style={{ marginBottom: "16px", width: "100%" }}
//               />
//             ) : key === "center_of_park" ? (
//               <input
//                 type="file"
//                 accept=".txt"
//                 onChange={(e) => handleFileChange(e, key)}
//                 ref={centerParkRef} // Assign ref
//                 style={{ marginBottom: "16px", width: "100%" }}
//               />
//             ) : (
//               <TextField
//                 label={key.charAt(0).toUpperCase() + key.slice(1)}
//                 variant="outlined"
//                 name={key}
//                 fullWidth={true}
//                 value={formData[key]}
//                 onChange={handleValueChange}
//                 sx={{ mb: 2 }}
//               />
//             )}
//           </Grid>
//         ))}
//         {responseMessage && (
//           <Grid item xs={12}>
//             {responseMessage}
//           </Grid>
//         )}
//       </FormContainer>
//     </>
//   );
// }

// export default RegisterPark;

////////
import React, { useState, useRef } from "react";
import { Alert, Grid, TextField, TextareaAutosize } from "@mui/material";
import FormContainer from "../../../../../components/Forms/FormContainer";
import { ExecuteApiToPost } from "../../../../../services/api/ExecuteApiRequests";

const initialData = {
  id: "",
  name: "",
  region: "",
  compound_boundary: null,
  specialization: "",
  developed_by: "",
  area_on_plan: "",
  current_status: "",
  description: "",
  abbrevation: "",
  zone: "",
  city: "",
  center_of_park: null,
  pid: "",
  woreda: "",
  address: "",
  distance_from_capital: "",
};

function RegisterPark() {
  const [formData, setFormData] = useState(initialData);
  const [responseMessage, setResponseMessage] = useState(null);
  const compoundBoundaryRef = useRef(null);
  const centerParkRef = useRef(null);

  const handleValueChange = (e) => {
    const { name, value } = e.target;
    
    // Convert distance_from_capital to float
    if (name === "distance_from_capital") {
      // Allow empty string or valid float numbers
      if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const hexValue = event.target.result.trim();
        setFormData((prev) => ({ ...prev, [field]: hexValue }));
      };
      reader.onerror = () => {
        alert("Error reading file");
      };
      reader.readAsText(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Convert distance_from_capital to float before submission
    const submissionData = {
      ...formData,
      distance_from_capital: formData.distance_from_capital === "" ? null : parseFloat(formData.distance_from_capital)
    };

    console.log("Form Data before submission:", submissionData);

    if (!submissionData.id) {
      setResponseMessage(<Alert severity="error">ID is required</Alert>);
      return;
    }

    const formDataToSend = new FormData();
    for (const key in submissionData) {
      formDataToSend.append(key, submissionData[key]);
    }

    try {
      const data = await ExecuteApiToPost("parks", formDataToSend);
      if (data) {
        setResponseMessage(<Alert severity="success">Park registered successfully</Alert>);
        // Clear form data and file inputs
        setFormData(initialData);
        compoundBoundaryRef.current.value = ""; // Clear the file input
        centerParkRef.current.value = ""; // Clear the file input
      }
    } catch (error) {
      setResponseMessage(<Alert severity="error">Error registering park</Alert>);
      console.error("Error registering park:", error);
    }
  };

  return (
    <>
      <FormContainer title="Park Registration" onSubmit={handleSubmit}>
        {Object.keys(initialData).map((key) => (
          <Grid item xs={12} key={key}>
            {key === "description" ? (
              <TextareaAutosize
                aria-label={`${key.charAt(0).toUpperCase() + key.slice(1)} Description`}
                name={key}
                minRows={4}
                placeholder={`${key.charAt(0).toUpperCase() + key.slice(1)} Description`}
                style={{
                  width: "100%",
                  padding: 10,
                  borderRadius: 4,
                  borderColor: "#c4c4c4",
                  marginBottom: "16px",
                }}
                value={formData[key]}
                onChange={handleValueChange}
              />
            ) : key === "compound_boundary" ? (
              <input
                type="file"
                accept=".txt"
                onChange={(e) => handleFileChange(e, key)}
                ref={compoundBoundaryRef}
                style={{ marginBottom: "16px", width: "100%" }}
              />
            ) : key === "center_of_park" ? (
              <input
                type="file"
                accept=".txt"
                onChange={(e) => handleFileChange(e, key)}
                ref={centerParkRef}
                style={{ marginBottom: "16px", width: "100%" }}
              />
            ) : key === "distance_from_capital" ? (
              <TextField
                label="Distance from Capital (km)"
                variant="outlined"
                name={key}
                fullWidth={true}
                value={formData[key]}
                onChange={handleValueChange}
                sx={{ mb: 2 }}
                type="number"
                inputProps={{ 
                  step: "0.1",
                  min: "0"
                }}
                placeholder="Enter distance in kilometers"
              />
            ) : (
              <TextField
                label={key.charAt(0).toUpperCase() + key.slice(1)}
                variant="outlined"
                name={key}
                fullWidth={true}
                value={formData[key]}
                onChange={handleValueChange}
                sx={{ mb: 2 }}
              />
            )}
          </Grid>
        ))}
        {responseMessage && (
          <Grid item xs={12}>
            {responseMessage}
          </Grid>
        )}
      </FormContainer>
    </>
  );
}

export default RegisterPark;
/////////